import { render, staticRenderFns } from "./quickRegistrationRecord.vue?vue&type=template&id=99d622ac&scoped=true&"
import script from "./quickRegistrationRecord.vue?vue&type=script&lang=js&"
export * from "./quickRegistrationRecord.vue?vue&type=script&lang=js&"
import style0 from "./quickRegistrationRecord.vue?vue&type=style&index=0&id=99d622ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d622ac",
  null
  
)

export default component.exports